import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import LibraryAddCheckIcon from "@material-ui/icons/LibraryAddCheck";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import FormatShapesIcon from "@material-ui/icons/FormatShapes";
import LinkIcon from "@material-ui/icons/Link";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import PageviewIcon from "@material-ui/icons/Pageview";
import PresentToAllIcon from "@material-ui/icons/PresentToAll";
import VisibilityIcon from "@material-ui/icons/Visibility";
import HeadsetIcon from "@material-ui/icons/Headset";
import MicIcon from "@material-ui/icons/Mic";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import GroupIcon from "@material-ui/icons/Group";

export const getIcon = (link: any) => {
    switch (link) {
      case "findTheDiff":
      case "FindTheSchwa":
      case "FindTheStressedWords":
      case "FindTheFocus":
        return <SearchIcon />;
      case "checkUnderstanding":
        return <LibraryAddCheckIcon />;
      case "recordAndCompare":
        return <SwapHorizIcon />;
      case "chooseThePicture":
        return <AddPhotoAlternateIcon />;
      case "matchTheSound":
        return <FormatShapesIcon />;
      case "linkTheSounds":
        return <LinkIcon />;
      case "ListenStressedSyllable":
        return <VolumeUpIcon />;
      case "MatchTheStress":
        return <ViewModuleIcon />;
      case "ChooseTheRightWord":
      case "ChooseTheRightIntonation":
      case "ChooseTheRightPhrasing":
        return <PageviewIcon />;
      case "Numbers":
      case "CompoundNouns":
      case "Suffixes":
      case "StressedWords":
      case "EmphasizingKeyWords":
      case "UnstressedWords":
      case "DisappearingSounds":
      case "ReducedSpeechCommonExpressions":
      case "QuestionsAndStatements":
      case "ClarifyingAndConfirming":
      case "Lists":
      case "ConsonantSameConsonant":
      case "ConsonantVowel":
      case "Consonanty":
      case "VowelVowel":
      case "SyllablesAndStress":
      case "UnstressedSyllables":
      case "PairedNounsAndVerbs":
        return <PresentToAllIcon />;
      case "PredictStressTitle":
      case "PredictStressWord":
      case "PredictUnstressedWord":
      case "PredictTheIntonation":
      case "CountTheSyllablesTitle":
        return <VisibilityIcon />;
      case "ListenForTheIntonation":
        return <HeadsetIcon />;
      case "Dictation":
        return <MicIcon />;
      case "RecognizeReducedSpeech":
        return <PlaylistAddCheckIcon />;
      case "GroupingRelatedIdeas":
      case "GroupTheIdeas":
        return <GroupIcon />;
      default:
        break;
    }
  };